import { InputVariantTypes, PAYMENT_TYPE } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import { RadioGroup } from "../RadioGroup";
import { TextField } from "../TextField";
import { Typography } from "../Typography";
import { CardDetailsDisplay } from "./CardDetailsDisplay";

export const PBIFieldsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CardViewEditContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
`;

const StyledRadio = styled(RadioGroup)`
  margin-bottom: 28px;
`;

type Props = {
  setPoNumber: (poNumber: string) => void;
  poNumber: string;
  setTaxCode: (taxCode: string) => void;
  taxCode: string;
  setIsEditing: (isEditing: boolean) => void;
  isCardDetailsEditing: boolean;
  paymentType: PAYMENT_TYPE;
  setPaymentType: (paymentType: PAYMENT_TYPE) => void;
  maskedCardNumber: string;
  isPayByInvoiceCustomer: boolean;
};

export const PaymentOptionSelection = ({
  setPoNumber,
  poNumber,
  setTaxCode,
  taxCode,
  setIsEditing,
  isCardDetailsEditing,
  setPaymentType,
  paymentType,
  maskedCardNumber: lastFourDigits,
  isPayByInvoiceCustomer,
}: Props) => {
  const handlePaymentMethodChange = (value: PAYMENT_TYPE) => {
    setPaymentType(value);
    setIsEditing(false);
  };

  const paymentTypes = [
    {
      label: "Pay by card",
      value: PAYMENT_TYPE.CARD,
    },
    {
      label: "Invoice",
      value: PAYMENT_TYPE.INVOICE,
    },
  ];

  return (
    <PBIFieldsContainer>
      <StyledRadio
        labelHidden
        id="payment-method"
        orientation="horizontal"
        ariaLabel="Select payment method"
        onValueChange={handlePaymentMethodChange}
        value={paymentType}
        items={
          isPayByInvoiceCustomer ? [...paymentTypes].reverse() : paymentTypes
        }
      />
      {!isCardDetailsEditing && (
        <div>
          {paymentType === PAYMENT_TYPE.INVOICE ? (
            <>
              <TextField
                dense
                id="PO-number"
                variant={InputVariantTypes.SNOWDROP}
                label="PO number (optional)"
                name="PO number"
                onChange={(event) => setPoNumber(event.target.value)}
                value={poNumber}
                placeholder="e.g. 1234567"
                maxLength={30}
                showCharacterCount
              />
              <div style={{ marginTop: "12px" }}>
                <TextField
                  dense
                  id="tax-code"
                  variant={InputVariantTypes.SNOWDROP}
                  label="Tax code (optional)"
                  name="Tax code"
                  onChange={(event) => setTaxCode(event.target.value)}
                  value={taxCode}
                  placeholder="e.g. 1234567"
                  maxLength={30}
                  showCharacterCount
                />
              </div>
            </>
          ) : (
            <CardViewEditContainer>
              <CardDetailsDisplay lastFourDigits={lastFourDigits} />
            </CardViewEditContainer>
          )}
        </div>
      )}
    </PBIFieldsContainer>
  );
};
